import { configureStore } from '@reduxjs/toolkit';
// import AssignmentStartEndTimeShow from './Interpreter/AssignmentStartEndTimeShow';
import AssignmentStartEndIntDuration from './Interpreter/AssignmentStartEndIntDuration';

export default configureStore({
  reducer: {
    assignmentinterpretedduration: AssignmentStartEndIntDuration,
  },
});
